import { makeAutoObservable } from "mobx";

type DocumentType = "SESSION" | "CHART";

class ConcurrentEditStore {
  currentEditing: {
    documentId: number;
    documentType: DocumentType;
  } | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentEditing(info: { documentId: number; documentType: DocumentType }) {
    this.currentEditing = info;
  }

  clearCurrentEditing() {
    this.currentEditing = null;
  }
}

export default new ConcurrentEditStore();
